import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Button, Stack, Tab } from '@mui/material'
import { CheckPoint, Floor } from 'interface'
import { SyntheticEvent, useState } from 'react'
import FloorImageMap from './Map/FloorImageMap'

interface IProps {
  floors: Floor[]
  curPoint?: CheckPoint
  positions: CheckPoint[]
  canEdit?: boolean
  useEdit?: () => void
  addPosition?: (val: { lat: number; lng: number }) => void
  updatePosition?: (val: { lat: number; lng: number }) => void
}
export default function FloorMap({
  floors = [],
  curPoint,
  positions,
  canEdit,
  useEdit,
  addPosition,
  updatePosition,
}: IProps) {
  const [floor, setFloor] = useState(() => {
    if (curPoint) return Math.round(curPoint.lat / 1000).toString()
    else return floors[0]?.id.toString() || ''
  })
  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setFloor(newValue)
  }
  return floor ? (
    <Box
      sx={{
        p: 2,
        boxShadow: '0px 0px 20px rgba(0,0,0,0.2),0 0 10px rgba(0,0,0,0.1)',
      }}
    >
      <TabContext value={floor}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              width: '100%',
            }}
          >
            {floors?.map((f, i) => {
              return <Tab key={i} label={f.floorName} value={f.id.toString()} />
            })}
          </TabList>
        </Box>
        <Box sx={{ width: '100%' }}>
          {floors.map((f, i) => {
            return (
              <TabPanel key={f.id} value={f.id.toString()}>
                {floor === f.id.toString() && (
                  <FloorImageMap
                    floor={f}
                    positions={positions
                      .filter((p) => Math.round(p.lat / 1000) === f.id)
                      .filter((p) => !canEdit || p.id !== curPoint?.id)
                      .map((v) => ({
                        x: v.lat % 1000,
                        y: v.lng % 1000,
                      }))}
                    initPoint={
                      !canEdit
                        ? curPoint && {
                            x: curPoint.lat % 1000,
                            y: curPoint.lng % 1000,
                          }
                        : undefined
                    }
                  />
                )}
              </TabPanel>
            )
          })}
        </Box>
      </TabContext>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {!canEdit && useEdit ? (
          <Button color="info" variant="contained" onClick={useEdit}>
            修正する
          </Button>
        ) : (
          curPoint && (
            <Button color="warning" variant="outlined" onClick={useEdit}>
              キャンセル
            </Button>
          )
        )}
      </Stack>
    </Box>
  ) : (
    <></>
  )
}
